import { useAwaitControl } from 'react-redux-await-control';
import { useDispatch } from 'react-redux';
import AsyncActionControl from 'react-redux-await-control/dist/AsyncActionControl';
import { createAction } from 'redux-actions';

export const updateSpecificState = (action: AsyncActionControl, data: any, actionId?: string | number) =>
  createAction(
    `${action.label}_UPDATE`,
    () => data,
    () => ({ actionId }),
  ).call(this);

export const getAsyncActionResultSelector = (action: AsyncActionControl) =>
  function selector(state: any) {
    const actionData = state?.getIn(['rrAwaitControl', action.rawKey]);
    if (!actionData) return null;
    return actionData?.[1];
  };

export default function useAsyncActionStatus(asyncAction: AsyncActionControl, actionId?: string | number) {
  const control = useAwaitControl(asyncAction);
  const dispatch = useDispatch();

  const result = control.result(actionId);
  const loading = control.isRunning(actionId);
  const success = control.isSuccessful(actionId);
  const failure = control.hasFailure(actionId);
  const cancelled = control.wasCancelled(actionId);

  const update = (data: any) => {
    if (!success) return;
    dispatch(updateSpecificState(asyncAction, data, actionId));
  };

  const clear = () => {
    control.clear({ actionId });
  };

  const start = (data?: any, meta?: any) => {
    if (data) {
      control.start(data, meta || { actionId });
    } else {
      control.start(meta || { actionId });
    }
  };

  return {
    result,
    loading,
    success,
    failure,
    cancelled,
    start,
    clear,
    update,
  };
}
